import { URL_TO_WIDGET, URL_VISITED, URL_DONT_LOAD_WIDGET } from '../config'
import { buildDynamicHours } from './buildDynamicHours'
import { calcMinutes } from './calcMinutes'

export function dynamicHours() {
  if (!URL_TO_WIDGET.includes(URL_VISITED)) return
  if (URL_DONT_LOAD_WIDGET.includes(URL_VISITED)) return

  const hours = buildDynamicHours()

  const observer = new MutationObserver(() => {
    const $DSA = document.getElementById('dsa')

    if ($DSA !== null) {
      $DSA.addEventListener('click', () => {
        const $hourSelect = document.getElementById('wm_shedule-values')

        hours.forEach((hour) => {
          const option = document.createElement('option')
          option.innerText = hour

          if (hour.includes('amanhã')) {
            const [, realHour] = hour.split(' ')
            option.value = calcMinutes({ hour: realHour, tomorrow: true })
          } else {
            option.value = calcMinutes({ hour, tomorrow: false })
          }

          $hourSelect.appendChild(option)
        })

        $hourSelect.addEventListener('change', (event) => {
          const [$minutesTag] = document.getElementsByName('minutes')

          $minutesTag.setAttribute('value', event.target.value)
        })
      })

      observer.disconnect()
    }
  })

  observer.observe(document.body, { childList: true, subtree: true })
}
